// extracted by mini-css-extract-plugin
export default {"root":"login_root__+5zrY","content":"login_content__qgz35"};